import { create } from 'zustand';

import { IFunnelRequestBody } from '@src/emp-3.0/types';

export interface IFunnelStore {
  funnelRequestBody: IFunnelRequestBody;
  setFunnelRequestBody: (data: Partial<IFunnelRequestBody>) => void;
  generateFunnelRequestBody: IFunnelRequestBody;
  setGenerateFunnelRequestBody: (data: Partial<IFunnelRequestBody>) => void;
  userIds: string[];
  setUserIds: (userIds: string[]) => void;
  funnelData: {
    event_names: string[];
    funnel_data: any[];
  };

  setFunnelData: (funnelData: { event_names: string[]; funnel_data: any[] }) => void;
}

const defaultFunnelRequestBody: IFunnelRequestBody = {
  funnel_events: [{ event_name: '', filters: [] }],
  interval: '',
  filters: [[{ field: 'app_id', op: 'eq', value: [] }]],
  dimension_breakdowns: [[{ field: '', op: 'eq', value: [] }]],
};

export const useFunnelStore = create<IFunnelStore>((set) => ({
  funnelRequestBody: defaultFunnelRequestBody,
  setFunnelRequestBody: (data) => {
    set((state) => {
      const newFunnelRequestBody: IFunnelRequestBody = { ...state.funnelRequestBody, ...data };

      return { funnelRequestBody: { ...newFunnelRequestBody } };
    });
  },
  generateFunnelRequestBody: defaultFunnelRequestBody,
  setGenerateFunnelRequestBody: (data) => {
    set((state) => {
      const newFunnelRequestBody: IFunnelRequestBody = {
        ...state.generateFunnelRequestBody,
        ...data,
      };

      return { generateFunnelRequestBody: { ...newFunnelRequestBody } };
    });
  },
  userIds: [],
  setUserIds: (userIds) => {
    set({ userIds });
  },
  funnelData: {
    event_names: [],
    funnel_data: [],
  },
  setFunnelData: (funnelData) => {
    set({ funnelData });
  },
}));
